// useGetWeekMenu.js
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { WiMuleSQL } from "../../services/WiMuleSQL";

const fetchWeekMenu = async (weekStart) => {
  const response = await axios.get(`${WiMuleSQL}/api/LunchMenu/GetWeekMenu`, {
    params: { weekStart },
  });
  return response.data.data;
};

export const useGetWeekMenu = (weekStart) =>
  useQuery({
    queryKey: ["weekMenu", weekStart],
    queryFn: () => fetchWeekMenu(weekStart),
    enabled: !!weekStart,
  });
